var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9459 8.33366C12.9459 9.94449 11.6401 11.2503 10.0292 11.2503C8.41842 11.2503 7.11255 9.94449 7.11255 8.33366C7.11255 6.72283 8.41842 5.41699 10.0292 5.41699C11.6401 5.41699 12.9459 6.72283 12.9459 8.33366Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.66699C6.31802 1.66699 3.33325 4.68185 3.33325 8.40091C3.33325 10.5274 4.16659 12.1809 5.83325 13.6578C7.00801 14.6988 9.14542 16.9319 9.99992 18.3336C10.8977 16.9598 12.9918 14.6988 14.1666 13.6578C15.8333 12.1809 16.6666 10.5274 16.6666 8.40091C16.6666 4.68185 13.6818 1.66699 9.99992 1.66699Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcv);
export default __webpack_public_path__ + "static/media/location_icv.abe3eb3ffee3d84f52d5eca2b396bf4e.svg";
export { ForwardRef as ReactComponent };